import { JsonReply, Partaker } from "@grupo-constant/next-dtype/types";
import { adminUri, developerUri, UserNodePrivileges, UserProfile } from "../endpoints/endpoints.types";
import { CompanyUser } from "../../../core/user/user.types";

export const OU_URI = 'dtype://com.cloudcodice.thirdparty.grupoconstant.net2beeple.DBConnectCoreOu';

export interface Net2BeepleOu {
    ou?: string;
    name?: string;
    admin?: (string | CompanyUser | UserProfile)[];
    [adminUri]?: UserProfile[];
    developer?: (string | CompanyUser | UserProfile)[];
    [developerUri]?: UserProfile[];
    role?: UserNodePrivileges;
}

export interface RetrieveNet2BeepleOuReply extends JsonReply {
    net2BeepleOu?: Net2BeepleOu;
    partaker?: Partaker;
}

export interface UpdateNet2BeepleOuReply extends JsonReply {
    net2BeepleOu?: Net2BeepleOu;
}
